import { defineComponent as _defineComponent } from 'vue'
import MediaItem from '../MediaItem/MediaItem.vue'
import CommonTokenMoney from '@/components/shared/CommonTokenMoney.vue'
import type { NFT } from '@/components/rmrk/service/scheme'
import { getChainNameByPrefix } from '@/utils/chain'
import { NeoSkeleton, NftCardVariant } from '@kodadot1/brick'


export default /*#__PURE__*/_defineComponent({
  __name: 'NeoNftCard',
  props: {
    isLoading: { type: Boolean },
    nft: null,
    prefix: null,
    showPrice: { type: Boolean },
    collectionPopoverShowDelay: { default: 500 },
    variant: { default: 'primary' },
    placeholder: null,
    unlockable: { type: Boolean },
    unloackableIcon: { default: undefined },
    link: { default: 'a' },
    bindKey: { default: 'href' }
  },
  setup(__props: any) {



return { __sfc: true,MediaItem, CommonTokenMoney, getChainNameByPrefix, NeoSkeleton }
}

})